import { Modal } from 'src/modules/common/components/Modal/Modal.tsx';
import { useContext } from 'react';
import { ConfigContext } from 'src/configContext.ts';
import { ModalHeader } from 'src/modules/common/components/Modal/ModalHeader.tsx';
import { ModalBody } from 'src/modules/common/components/Modal/ModalBody.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { I18n } from '../I18n/I18n';

export const ErrorModal = () => {
    const { rootElement } = useContext(ConfigContext);

    return (
        <Modal opened={true} size="sm" handleClose={() => null} root={rootElement} danger={true}>
            <ModalHeader title={MESSAGES.somethingWrongModalSubtitle}/>

            <ModalBody>
                <div className="vss-error-modal">
                    <p className="vss-error-modal__message">
                        <I18n messageId={MESSAGES.somethingWrongModalMessage}/>
                    </p>
                </div>
            </ModalBody>
        </Modal>
    );
};
